export const updatingClass = (updating) => {
  return updating ? 'updating' : '';
};

export const formatPrice = ({ price, included = false, zeroTranslations }) => {
  if (price == undefined) {
    return;
  }

  if (price === 0) {
    if (included) {
      return zeroTranslations.included;
    }
    return zeroTranslations.free;
  }

  if (price == -1) {
    return zeroTranslations.onInquiry;
  }

  const ietfLanguageTag = document.documentElement.getAttribute('data-lang');
  const currency = document.documentElement.getAttribute('data-currency');

  return new Intl.NumberFormat(ietfLanguageTag, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);
};

export const calculateServiceCharges = ({
  adults,
  children,
  juniors,
  nights,
  cabinPriceSlow,
}) => {
  // Get the service charges for adults (SERVICE-CHARGE-A), children (SERVICE-CHARGE-C)
  let serviceChargeAdult = cabinPriceSlow.price_service_charge_a?.value || 0;
  let serviceChargeChild = cabinPriceSlow.price_service_charge_c?.value || 0;
  let serviceChargeJunior = cabinPriceSlow.price_service_charge_j?.value || 0;

  // Calculate total service charges
  let totalServiceCharges =
    (adults * serviceChargeAdult +
      children * serviceChargeChild +
      juniors * serviceChargeJunior) *
    nights;

  return totalServiceCharges;
};

export const calculatePortFees = ({
  adults,
  children,
  juniors,
  cabinPriceSlow,
}) => {
  // Get the port fees for adults (GFT-A), children (GFT-C), and juniors (GFT-J)
  let gftAdult = cabinPriceSlow.price_gft_a?.value || 0;
  let gftChild = cabinPriceSlow.price_gft_c?.value || 0;
  let gftJunior = cabinPriceSlow.price_gft_j?.value || 0;

  // Calculate total port fees
  let totalPortFees =
    adults * gftAdult + children * gftChild + juniors * gftJunior;

  return totalPortFees;
};

export const isCombinationValidForCabin = (object) => {
  let key = `price_${object.adults}a`;

  if (object.child > 0) {
    key += `${object.child}c`;
  }
  if (object.junior > 0) {
    key += `${object.junior}j`;
  }

  // Check if the combination exists in the prices object
  return object.prices[key] && object.prices[key].value !== null;
};
